import { CashRegister, CashRegisterState } from "@resamare/models";
import { useQuery } from "@tanstack/react-query";
import { array, boolean, number, object, string } from "yup";
import { apiClient } from "../../../config";
import { useAdmin } from "../../auth";

export const cashRegistersResponseSchema = array()
    .of(
        object().shape({
            caisseId: number().required().positive().integer(),
            nomCaisse: string().required(),
            etatCaisse: number<CashRegisterState>()
                .required()
                .oneOf(Object.values(CashRegisterState) as number[]),
            etatCaisseValide: boolean().required(),
        }),
    )
    .required();

async function getCashRegisters(adminId: number): Promise<CashRegister[]> {
    try {
        const response = await apiClient.get(`/api/caisses/${adminId}`, {
            skipLogHttpErrors: [500],
        });
        const cashRegisters = await cashRegistersResponseSchema.validate(response.data, {
            stripUnknown: true,
        });
        return cashRegisters;
    } catch {
        return [];
    }
}

export function useGetCashRegisters() {
    const { admin } = useAdmin();

    const query = useQuery({
        queryKey: ["cash-registers"],
        queryFn: () => getCashRegisters(admin.admin_id),
    });

    return query;
}
